module.exports = __webpack_public_path__ + "static/media/send-button.44e85421.svg";